<template>
<v-container class="component_main px-6">
  <v-row>
    <v-col cols="8">
    <CronogramaForm 
      :close="(formData)=>saveItem(formData)" 
      :dadoscronograma="dadoscronograma" 
      :disableFields="!isNew" 
      :isNew="isNew" 
      :isComplementar="isComplementar"
    />
    </v-col>
  </v-row>
</v-container>
</template>
<script>
import { mapState } from "vuex"
import CronogramaForm from "@/components/faturamento/cronograma_form/cronogramaForm"

export default {
  props:{
    close: Function,
  },
  components:{
    CronogramaForm
  },
  data() {
    return {
      isNew: false,
      isComplementar: false,
      dadoscronograma: {
        grupo_economico: null,
        dt_faturamento: null,
        dt_prev_vencimento: null,
        id: null,
        prestador_id: null, //
        owner_id: null,
        operadora_ans_id: null, //
        vl_prev_faturamento: null,
        qtd_dias_notificacao: null,
        recorrencia: null,
        ocorrencia: null,
        login_prestador: "", // Identificação do prestador
        tipo_guia: null, //
        config: null
      }
    }
  },
  beforeMount() {
    this.isNew = this.$route.params.id? false : true
    this.isComplementar = !!this.$route.query.complementar
    if(this.$route.params.id){
      this.dadoscronograma.id = this.$route.params.id
      this.$store.dispatch("faturamento/getDetalhesCronograma", this.$route.params).then(resp => {
        this.dadoscronograma = resp
        this.dadoscronograma.login_prestador = resp.login_prestador? resp.login_prestador : ""
        this.dadoscronograma.tipo_guia = resp.tipo_guia? resp.tipo_guia : null
        })
    }
  },
  computed: {
    ...mapState({
      grupoEconomico: (state) => state.permissions.grupoEconomico,
    })
  },
  methods: {
    saveCallback(){
      if (this.isComplementar) {
          this.$router.push('/recebiveis/lotespendentes')
        } else {
          this.$router.go(-1)
        }
    },
    saveItem(formData) {
      if(!formData){
        this.saveCallback()
      } else {
        formData.grupo_economico = this.grupoEconomico
        let acao = ""
        if (this.isComplementar) {
          acao = formData.id ? "updatecronograma" : "addcronogramacomplementar"
        } else {
          acao = formData.id ? "updatecronograma" : "addcronograma"
        }
        
        let payload = formData

        var data = {
          query: 
          [{
            "Modulo": "faturamento",
            "Acao": acao,
            "Payload": payload
          }]
        };
        this.$store.dispatch("request/doRequest", data).then((response) => {
          if (!response || response.isAxiosError || !response.sucesso) {
            this.$store.commit("hideLoader");
            return;
          }
          let paramModal = {
            type: "success",
            title: "Sucesso!",
            message: response.mensagem,
            callback: this.saveCallback,
            btConfirm: { name: "Ok", show: true },
          }
          this.$store.commit("confirmMessage/showConfirmMessage", paramModal);
        })
      }
    }
  }
}
</script>
<style>
</style>